/**
 * Mirrors SearchController#resolve_mls_numbers ID normalization:
 * comma/space split, reject blanks, cap 200, strip single quotes, uppercase.
 *
 * @param {string} listingIds - e.g. expanded range string from _expandRanges (comma-separated)
 * @returns {string[]}
 */
export function normalizeListingIdsFromExpandedString(listingIds) {
  if (listingIds == null || String(listingIds).trim() === '') {
    return [];
  }
  const parts = String(listingIds)
    .replace(/,/g, ' ')
    .split(/\s+/)
    .filter((p) => p.length > 0)
    .slice(0, 200);
  return parts.map((id) => id.replace(/'/g, '').toUpperCase());
}

/**
 * Stable signature for MLS hidden fields (ListingKey and ListingId) for change detection.
 *
 * @param {HTMLElement} containerEl - hidden container element
 * @returns {string}
 */
export function mlsResolutionSignatureForHiddenContainer(containerEl) {
  if (!containerEl) {
    return '';
  }
  const keyInputs = containerEl.querySelectorAll(
    'input[name="search_fields[ListingKey][value][]"]'
  );
  const idInputs = containerEl.querySelectorAll(
    'input[name="search_fields[ListingId][value][]"]'
  );
  const keys = Array.from(keyInputs)
    .map((el) => el.value)
    .filter(Boolean)
    .sort();
  const ids = Array.from(idInputs)
    .map((el) => el.value)
    .filter(Boolean)
    .sort();
  if (keys.length === 0 && ids.length === 0) {
    return '';
  }
  return `K:${keys.join('|')}|I:${ids.join('|')}`;
}
